import Errors from "@shared/errors";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const initialState = () => {
    return {
        paymentStatus: "",
        invoiceStatus: "",
        invoiceCart: { p_name: "", p_price: 0.0 },
        invoices: [],
        invoicesCount: 0,
        invoiceErrors: new Errors(),
        paymentErrors: new Errors(),
    };
};

const state = {
    initialState: initialState,
    ...initialState(),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
